import { createReducer } from 'typesafe-actions';
import { createRoutineReducers, getInitialState } from '../common/utils/routine-reducer.js';
import { CLEAR_STATUS_UPDATE_LIST, getStatusUpdateListRoutine } from './actions.js';

export type ScheduleState = {
  loading: boolean;
  loaded: boolean;
  saving: boolean;
  error: string;
  data: Record<string, string>;
};

export const initialState: ScheduleState = getInitialState({}, 'loading', 'loaded');

export default createReducer<ScheduleState>(initialState, {
  ...createRoutineReducers(getStatusUpdateListRoutine),
  [CLEAR_STATUS_UPDATE_LIST]: (state: ScheduleState): ScheduleState => ({
    ...state,
    data: {}
  })
});
